import { useRequestState } from "@/hooks";
import { useEffect } from "react";
import { requestNewsPageContent } from "@/services/api/news/requests";
import { AccountInfo } from "@azure/msal-browser";
import { NewsContentPageResponse } from "@/services/api";

export const usePageContent = (account: AccountInfo | null | undefined) => {
  const { isLoading, data, error, setInProgress, setSuccess, setError } =
    useRequestState<NewsContentPageResponse>({ isLoading: true });

  useEffect(() => {
    const controller = new AbortController();
    setInProgress();

    requestNewsPageContent(
      {
        email: account?.username ?? "",
        pageName: "Main",
      },
      { signal: controller.signal },
    )
      .then(response => setSuccess(response))
      .catch(() => {
        setError(error);
      });

    return () => {
      controller.abort();
    };
  }, [account, error, setError, setInProgress, setSuccess]);

  return {
    isLoadingPageContent: isLoading,
    pageContent: data,
    errorPageContent: error,
  };
};
